import {
  BarChartOutlined,
  DashboardOutlined,
  LineChartOutlined,
  PieChartOutlined,
  ProjectOutlined,
  TableOutlined
} from "@ant-design/icons"
import React from "react"

import type { ReportDefinitionV1 } from "../types/canvas.types.ts"

const REPORT_ICON_KEYS = [
  "bar_chart",
  "pie_chart",
  "line_chart",
  "table",
  "dashboard",
  "project"
] as const

type ReportIconKey = (typeof REPORT_ICON_KEYS)[number]

const DEFAULT_REPORT_ICON: ReportIconKey = "bar_chart"

const REPORT_ICON_COMPONENTS: Record<
  ReportIconKey,
  React.ComponentType<{ style?: React.CSSProperties; className?: string }>
> = {
  bar_chart: BarChartOutlined,
  pie_chart: PieChartOutlined,
  line_chart: LineChartOutlined,
  table: TableOutlined,
  dashboard: DashboardOutlined,
  project: ProjectOutlined
}

const isReportIconKey = (value: unknown): value is ReportIconKey =>
  typeof value === "string" &&
  (REPORT_ICON_KEYS as readonly string[]).includes(value)

const reportIconKeyOf = (
  definition: Pick<ReportDefinitionV1, "icon"> | null | undefined
): ReportIconKey =>
  isReportIconKey(definition?.icon) ? definition.icon : DEFAULT_REPORT_ICON

interface ReportIconGlyphProps {
  iconKey?: string
  style?: React.CSSProperties
  className?: string
}

const ReportIconGlyph = ({ iconKey, style, className }: ReportIconGlyphProps) => {
  const key = isReportIconKey(iconKey) ? iconKey : DEFAULT_REPORT_ICON
  const Component = REPORT_ICON_COMPONENTS[key]
  return <Component style={style} className={className} />
}

export {
  REPORT_ICON_KEYS,
  DEFAULT_REPORT_ICON,
  isReportIconKey,
  reportIconKeyOf,
  ReportIconGlyph,
  type ReportIconKey
}
